
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pet-shipping/[state]",
      function () {
        return require("private-next-pages/pet-shipping/[state]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pet-shipping/[state]"])
      });
    }
  